import script from "./SelectSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSearch.vue?vue&type=script&setup=true&lang=js"

import "./SelectSearch.vue?vue&type=style&index=0&id=1c576ceb&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c576ceb"]])

export default __exports__